import {Check, Close} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {Button, Stack, useMediaQuery, useTheme} from '@mui/material'
import {useTranslation} from 'react-i18next'

type Props = {
  onCancel: () => void
  isValid?: boolean
  isSubmitting?: boolean
  readOnly?: boolean
}

export const FormActions = ({onCancel, isValid, isSubmitting}: Props) => {
  const {t} = useTranslation()
  const disabledSubmit = !isValid || isSubmitting
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Stack
      direction={isSmall ? 'column-reverse' : 'row'}
      spacing={1}
      justifyContent="flex-end"
      width={{xs: '100%', sm: 'auto'}}
    >
      <Button
        onClick={onCancel}
        startIcon={<Close />}
        fullWidth={isSmall}
        data-test-id="cancel-button"
      >
        {t('form.action.cancel')}
      </Button>
      <LoadingButton
        data-test-id="submit-button"
        key="submit-button"
        type="submit"
        variant="contained"
        startIcon={<Check />}
        loadingPosition="start"
        loading={isSubmitting}
        disabled={disabledSubmit}
        fullWidth={isSmall}
      >
        {t('form.action.save')}
      </LoadingButton>
    </Stack>
  )
}
